import { DASHBOARD_ROUTE_NAME } from '@/libs/route-name';

export const dashboardRoute = () => {
    return {
        name: DASHBOARD_ROUTE_NAME.DASHBOARD,
        path: 'dashboard',
        component: () => import('@/pages/dashboard/index.vue'),
    };
};
